var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "blog-slider" }, [
    _c("div", { ref: "blogSwiper", staticClass: "swiper-container" }, [
      _c(
        "div",
        { staticClass: "swiper-wrapper" },
        _vm._l(_vm.data, function(article, index) {
          return _c(
            "div",
            { key: index, staticClass: "swiper-slide reverse" },
            [
              _c("div", {
                staticClass: "image-block reverse",
                style: { backgroundImage: "url(" + article.image.src + ")" },
                attrs: { "data-aos": "fade-up", "data-aos-duration": "400" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "text-block" }, [
                _c("div", { staticClass: "text-wrapper" }, [
                  _c("span", [_vm._v(_vm._s(_vm.translation.latest))]),
                  _vm._v(" "),
                  _c("h2", { staticClass: "section-title" }, [
                    _vm._v(_vm._s(article.title))
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "section-description",
                    domProps: { innerHTML: _vm._s(article.summary_html) }
                  }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn",
                      attrs: { href: "/blogs/news/" + article.handle }
                    },
                    [_vm._v(_vm._s(_vm.translation.read_more))]
                  )
                ])
              ])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { ref: "prev", staticClass: "swiper-button-prev" }),
      _vm._v(" "),
      _c("div", { ref: "next", staticClass: "swiper-button-next" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }